import { useState, useEffect } from "react";
import Layout from "../Layout";
import Container from "@mui/material/Container";
import Alert from "@mui/material/Alert";
import Typography from "@mui/material/Typography";

const WrongDetails = () => {
    const [staffName, setStaffName] = useState("");

    useEffect(() => {
        let staff = "";
        try {
            const raw = sessionStorage.getItem("staff");
            staff = raw ? JSON.parse(raw) : "";
        } catch {
            staff = "";
        }
        setStaffName(staff);
    }, []);

    return (
        <Layout>
            <Container maxWidth="sm" sx={{ py: { xs: 4, sm: 6 }, textAlign: "center" }}>
                <Typography variant="h5" sx={{ mb: 2 }}>
                    Hi, {staffName}!
                </Typography>
                <Alert severity="info" sx={{ textAlign: "left" }}>
                    HR will review your details. Please check your emails for
                    further updates.
                </Alert>
            </Container>
        </Layout>
    );
};

export default WrongDetails;
